import {
  ApiFilterOperation,
  TableCells,
  TableColumn,
  TableFilterCells,
} from '@eas/common-web';

import { MinimalDistances } from '../../models';
import { inactiveColoredFactory } from '../../components/form/inactive-colored/inactive-colored';
import { coordinateValueMapper } from '../../composite/facility-column-mappers/coordinate-mapper';

import {
  useMinimalDistancesCategorySource,
  useMinimalDistancesDeterminationMethodSource,
} from './minimal-distances-api';
import { icoValueMapperFactory } from '../../composite/subject-column-mappers/ico-mapper';

export function useColumns(): TableColumn<MinimalDistances>[] {
  return [
    {
      datakey: 'ovzFacility.facilityId',
      name: 'IČP provozovny',
      width: 200,
      filterOperation: ApiFilterOperation.CONTAINS,
      CellComponent: inactiveColoredFactory(TableCells.TextCell),
      sortable: true,
      filterable: true,
      filterGroup: 1,
    },
    {
      datakey: 'ovzFacility.name',
      name: 'Název provozovny',
      width: 200,
      filterOperation: ApiFilterOperation.CONTAINS,
      CellComponent: inactiveColoredFactory(TableCells.TextCell),
      sortable: true,
      filterable: true,
      filterGroup: 1,
    },
    {
      datakey: 'sourceId',
      name: 'Číslo zdroje',
      width: 200,
      filterOperation: ApiFilterOperation.CONTAINS,
      CellComponent: inactiveColoredFactory(TableCells.TextCell),
      sortable: true,
      filterable: true,
      filterGroup: 0,
    },
    {
      datakey: 'name',
      name: 'Název zdroje',
      width: 200,
      filterOperation: ApiFilterOperation.CONTAINS,
      CellComponent: inactiveColoredFactory(TableCells.TextCell),
      sortable: true,
      filterable: true,
      filterGroup: 0,
    },
    {
      datakey: 'sourceCategory.code',
      name: 'Zařazení zdroje',
      width: 200,
      filterkey: 'sourceCategory.id',
      sortkey: 'sourceCategory.name',
      filterOperation: ApiFilterOperation.EQ,
      FilterComponent: TableFilterCells.useFilterSelectCellFactory(
        useMinimalDistancesCategorySource
      ),
      CellComponent: inactiveColoredFactory(TableCells.TextCell),
      sortable: true,
      filterable: true,
      filterGroup: 0,
    },
    {
      datakey: 'determinationMethod.code',
      name: 'Způsob určení min. vzdálenosti',
      width: 200,
      filterkey: 'determinationMethod.id',
      sortkey: 'determinationMethod.name',
      filterOperation: ApiFilterOperation.EQ,
      FilterComponent: TableFilterCells.useFilterSelectCellFactory(
        useMinimalDistancesDeterminationMethodSource
      ),
      CellComponent: inactiveColoredFactory(TableCells.TextCell),
      sortable: true,
      filterable: true,
      filterGroup: 0,
    },
    {
      datakey: 'wgs84Coordinates.lat',
      name: 'Zeměpisná šířka',
      width: 200,
      CellComponent: inactiveColoredFactory(TableCells.TextCell),
      FilterComponent: TableFilterCells.FilterNumberCell,
      sortable: true,
      filterable: false,
      filterGroup: 0,
      valueMapper: coordinateValueMapper,
    },
    {
      datakey: 'wgs84Coordinates.lon',
      name: 'Zeměpisná délka',
      width: 200,
      CellComponent: inactiveColoredFactory(TableCells.TextCell),
      FilterComponent: TableFilterCells.FilterNumberCell,
      sortable: true,
      filterable: false,
      filterGroup: 0,
      valueMapper: coordinateValueMapper,
    },
    {
      datakey: 'exemptFromMinDistances',
      name: 'Výjimka z MV',
      width: 200,
      CellComponent: inactiveColoredFactory(TableCells.BooleanCell),
      FilterComponent: TableFilterCells.FilterBooleanCell,
      sortable: true,
      filterable: true,
      filterGroup: 0,
    },
    {
      datakey: 'ovzFacility.operator.ico',
      name: 'IČO provozovatele provozovny',
      width: 200,
      filterOperation: ApiFilterOperation.CONTAINS,
      CellComponent: inactiveColoredFactory(TableCells.TextCell),
      sortable: true,
      filterable: true,
      filterGroup: 1,
      valueMapper: icoValueMapperFactory('ovzFacility.operator'),
    },
    {
      datakey: 'ovzFacility.operator.label',
      name: 'Název provozovatele provozovny',
      filterkey: 'ovzFacility.operator.name',
      sortkey: 'ovzFacility.operator.name',
      width: 200,
      filterOperation: ApiFilterOperation.CONTAINS,
      CellComponent: inactiveColoredFactory(TableCells.TextCell),
      sortable: true,
      filterable: true,
      filterGroup: 1,
    },
    {
      datakey: 'active',
      name: 'Aktivní',
      filterkey: 'active',
      sortkey: 'active',
      width: 200,
      filterOperation: ApiFilterOperation.EQ,
      FilterComponent: TableFilterCells.FilterBooleanCell,
      CellComponent: inactiveColoredFactory(TableCells.BooleanCell),
      sortable: true,
      filterable: true,
      filterGroup: 0,
    },
  ];
}
